import React from 'react';
import PdfCreator from './PdfCreator';

export default function PdfCreatorButton() {
  return <PdfCreator id="#pdf-export" />;
}
